import { useTranslation } from 'react-i18next';
import { cx } from '@/shared/lib/cx';
import s from './Spinner.module.css';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  /** Видимая подпись рядом со спиннером. */
  label?: string;
  /** Декоративный спиннер (внутри кнопки с aria-busy) — без роли и подписи для экранных дикторов. */
  decorative?: boolean;
  className?: string;
}

/** Индикатор ожидания. Для загрузки содержимого предпочтительнее Skeleton. */
export function Spinner({ size = 'md', label, decorative = false, className }: SpinnerProps) {
  const { t } = useTranslation('ui');
  if (decorative) return <span className={cx(s.spinner, s[size], className)} aria-hidden="true" />;
  return (
    <span className={cx(s.wrapper, className)} role="status">
      <span className={cx(s.spinner, s[size], s.accent)} aria-hidden="true" />
      {label ? <span>{label}</span> : <span className="visually-hidden">{t('loading')}</span>}
    </span>
  );
}
